import React,{Fragment} from 'react';
import Explore from '../components/Project/Explore';
export default function Project() {
return (
<Fragment>
<Explore/>
</Fragment>
)
}
